function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M26.4 0H2.599C1.715 0 0 1.715 0 2.6v23.8c0 .884 1.715 2.6 2.599 2.6h12.394V17.988h-3.996v-3.979h3.997v-3.063c0-3.746 2.835-5.969 6.177-5.969 1.6 0 2.443.172 2.844.225v3.792l-2.835-.001c-1.817 0-2.156.901-2.156 2.169v2.847h5.045l-.658 3.979h-4.387V29H26.4c.884 0 2.6-1.716 2.6-2.6V2.6c0-.885-1.716-2.6-2.6-2.6z"
});

var SvgFacebookLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 29 29"
}, props), _ref);

export default SvgFacebookLogo;